import React, { Component } from "react";
import PropTypes from "prop-types";
import * as config from "./scriptLoaderConfig";
import * as env from "../../../util/environment/environment";

/**
 * Dynamically loads JS scripts or React components
 *
 * Must pass in an api instance that has a function called 'getServiceMode' which makes a backend call for the configuration.
 * More information on the docs here:
 * https://www.npmjs.com/package/react-load-script
 *
 */

export const scripts = {
  googleRecaptchaUi: "googleRecaptchaUi",
  equifaxDeviceVerifyUi: "equifaxDeviceVerifyUi",
  googleAddressAutocompleteUi: "googleAddressAutocompleteUi",
  five9SocialWidget: "five9SocialWidget"
};

class ScriptLoader extends Component {
  constructor(props) {
    super(props);
    this.config = config[this.props.scriptName];
    if (!this.config) {
      throw `Failed to find config for ${this.props.scriptName}`;
    }
    this.state = {
      serviceMode: ""
    };
  }

  componentDidMount() {
    const { api, scriptName } = this.props;
    if (env.isProd()) {
      setTimeout(() => {
        this.setState({ serviceMode: "sandbox" });
      }, 0);
    } else {
      api.getServiceMode(scriptName).then(serviceMode => {
        this.setState({ serviceMode });
      });
    }
  }

  render() {
    const { serviceMode } = this.state;
    if (!serviceMode) {
      return null;
    }
    const service = this.config[serviceMode]
      ? this.config[serviceMode]
      : this.config.default;
    return service({ ...this.props });
  }
}

ScriptLoader.propTypes = {
  scriptLoaded: PropTypes.func,
  api: PropTypes.object.isRequired,
  scriptName: PropTypes.string.isRequired,
  apiKey: PropTypes.string
};

export default ScriptLoader;
